export default __webpack_public_path__ + "static/media/00.98927d4c.jpg";